import { create } from "zustand";
import { QuestionKeyList } from "../configs/config";

interface Profile {
  _id: string | null;
  email: string | null;
  name: string | null;
  pseudo: string | null;
  dogName: string | null;
  imageUrls: string[];
  traits: string[];
  accountVerified: boolean | null;
  accountVerificationSubmitted: boolean | null;
  questions: Question[];
  distance: number | null;
  isKmUnit: boolean;
  notificationFlags: NotificationFlags | null;
  location: [number, number] | null;
  matchs: string[];
  isWarnedMatch: boolean;
  birthDate: string | null;
  youRole: string | null;
  ageFrom: number | null;
  ageTo: number | null;
  themRole: string[];
}

interface NotificationFlags {
  email: boolean;
  push?: boolean;
  matchs: boolean;
  messages: boolean;
}

interface Question {
  key: QuestionKeyList;
  answer: string;
  enabled: boolean;
}

interface AboutYouConnectWithProps {
  birthDate: string;
  youRole: string;
  ageFrom: number;
  ageTo: number;
  themRole: string[];
}

interface UserState {
  profile: Profile;
  nbConvWithNewMessage: number;
  dogNameOnTopNavBar: string | null;

  setProfile: (user: Profile) => void;
  setTraits: (traits: string[]) => void;
  setDistance: (distance: number, isKmUnit: boolean) => void;
  setNotifFlags: ({ email, push, matchs, messages }: NotificationFlags) => void;
  setQuestions: (traits: Question[]) => void;
  setImageUrls: (imageUrls: string[]) => void;
  setAboutYouConnectWith: (data: AboutYouConnectWithProps) => void;
  setAccountVerificationSubmitted: (status: boolean) => void;
  addMatch: (userId: string) => void;
  setNbConvWithNewMessage: (value: number) => void;
  // setlocation: (value: [number, number]) => void;
  setDogNameOnTopNavBar: (dogName: string | null) => void;
}

export const useUserStore = create<UserState>((set) => ({
  profile: {
    _id: null,
    email: null,
    name: null,
    pseudo: null,
    dogName: null,
    imageUrls: [],
    traits: [],
    accountVerified: null,
    accountVerificationSubmitted: null,
    questions: [],
    distance: 5,
    isKmUnit: false,
    notificationFlags: null,
    location: null,
    matchs: [],
    isWarnedMatch: false,
    birthDate: null,
    youRole: null,
    ageFrom: null,
    ageTo: null,
    themRole: [],
  },
  aboutYouConnectWith: {
    birthDate: null,
    youRole: null,
    ageFrom: null,
    ageTo: null,
    themRole: null,
  },
  nbConvWithNewMessage: 0,
  dogNameOnTopNavBar: null,

  setProfile: (profile) => set({ profile }),
  setTraits: (traits) => set((state) => ({ profile: { ...state.profile, traits } })),
  setDistance: (distance, isKmUnit) => set((state) => ({ profile: { ...state.profile, distance, isKmUnit } })),
  setNotifFlags: ({ email, push, matchs, messages }) =>
    set((state) => ({ profile: { ...state.profile, notificationFlags: { email, push, matchs, messages } } })),
  setQuestions: (questions) => set((state) => ({ profile: { ...state.profile, questions } })),
  setImageUrls: (imageUrls) => set((state) => ({ profile: { ...state.profile, imageUrls } })),
  setAboutYouConnectWith: (data) => set((state) => ({ profile: { ...state.profile, ...data } })),
  setAccountVerificationSubmitted: (status) =>
    set((state) => ({ profile: { ...state.profile, accountVerificationSubmitted: status } })),
  addMatch: (userId) => set((state) => ({ profile: { ...state.profile, matchs: [...state.profile.matchs, userId] } })),
  setNbConvWithNewMessage: (value) => set((state) => ({ ...state, nbConvWithNewMessage: value })),
  // setlocation: (value) => set((state) => ({ profile: { ...state.profile, location: value } })),
  setDogNameOnTopNavBar: (dogNameOnTopNavBar) => set({ dogNameOnTopNavBar }),
}));

// Subscribe to store changes
// useUserStore.subscribe((state) => {
//   console.log("Store state changed:", state);
// });
